/**
 * ORL — specialty manifest.
 *
 * Maintained through the Specialty Registry. The manifest is data: the shell
 * reads it and knows nothing about this specialty.
 *
 * Legacy codes resolved here: ORL
 * Catalogue acts (NGAP Maroc): 87
 */
import { defineSpecialty } from "../types";

export const orl = defineSpecialty(
{
  "id": "orl",
  "label": "ORL",
  "short": "ORL",
  "scope": "Oto-rhino-laryngologie",
  "aliases": [
    "ORL"
  ],
  "doctorSpecs": [
    "ORL"
  ],
  "featureFlag": "ux.v2.orl",
  "theme": {
    "primary": "oklch(0.71 0.15 180)",
    "primaryForeground": "oklch(0.98 0.005 240)",
    "accent": "oklch(0.78 0.16 80)",
    "accentForeground": "oklch(0.18 0.02 240)",
    "destructive": "oklch(0.65 0.22 27)",
    "success": "oklch(0.78 0.18 150)",
    "warning": "oklch(0.78 0.16 80)",
    "surface": "oklch(0.205 0.006 240)",
    "radius": "0.75rem",
    "fontDisplay": "\"Inter\", ui-sans-serif, system-ui, sans-serif"
  },
  "navigation": [
    {
      "id": "consult",
      "label": "Consultation",
      "icon": "Stethoscope",
      "route": "/clinical/consult",
      "order": 1,
      "requires": []
    },
    {
      "id": "audiology",
      "label": "Audiologie",
      "icon": "Ear",
      "route": "/clinical/audiology",
      "order": 2,
      "requires": []
    },
    {
      "id": "endoscopy",
      "label": "Endoscopie",
      "icon": "Scan",
      "route": "/clinical/endoscopy",
      "order": 3,
      "requires": []
    },
    {
      "id": "surgery",
      "label": "Bloc",
      "icon": "Syringe",
      "route": "/clinical/surgery",
      "order": 4,
      "requires": []
    },
    {
      "id": "prescription",
      "label": "Ordonnance",
      "icon": "Pill",
      "route": "/clinical/prescription",
      "order": 5,
      "requires": []
    }
  ],
  "panels": [
    {
      "id": "audiometry",
      "label": "Audiométrie",
      "icon": "Ear",
      "component": "AudiometryPanel",
      "order": 1,
      "requires": []
    },
    {
      "id": "timeline",
      "label": "Chronologie",
      "icon": "History",
      "component": "PatientTimeline",
      "order": 2,
      "requires": []
    }
  ],
  "ngap": {
    "specialtyScope": "ORL",
    "subSpecialties": [
      "Consultation",
      "Audiométrie",
      "Endoscopie",
      "Chirurgie"
    ],
    "catalogueActs": 87
  },
  "terminology": {
    "icd10": [
      "H60",
      "H66",
      "H90",
      "J35"
    ],
    "loinc": [
      "46140-1",
      "69730-0"
    ],
    "snomed": []
  },
  "deviceProfiles": [
    "audiometer",
    "tympanometer",
    "endoscope-orl"
  ],
  "locales": [
    "fr",
    "ar"
  ]
}
);

export default orl;
